import { GuardianService } from '../../../_services/guardian.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../_services/admin.service';

import { Component, Input, OnInit } from '@angular/core';
import Swal  from 'sweetalert2';

@Component({
  selector: 'app-subscription-grouping-index',
  templateUrl: './subscription-grouping-index.component.html',
  styleUrls: ['./subscription-grouping-index.component.css']
})
export class SubscriptionGroupingIndexComponent implements OnInit {
  loading=false
  server_guardian_id:any=undefined
  guardian:any=undefined
  dtOptions: DataTables.Settings = {}
  subscriptionGroupingList = []
  @Input() subscriptionGroup = undefined


  constructor(private adminService:AdminService, private activeRoute:ActivatedRoute,private guardianService:GuardianService, private router:Router) { }

  ngOnInit(): void {
    this.loading=true
    this.activeRoute.params.subscribe(
      p=>{
        this.server_guardian_id = p.server_guardian_id
        if(this.server_guardian_id!=0){
          this.guardianService.getById(this.server_guardian_id).subscribe(
            g=>{
              this.guardian=g
            }
          )
          this.adminService.getSubscriptionGroupings(this.server_guardian_id).subscribe(
            values=>{
              this.subscriptionGroupingList = values
              this.loading=false
            })
        }
      }
    )

}
deleteGrouping(server_subscription_group_id:number){
  this.adminService.deleteGroupingByServerSubscriptionGroupingId(server_subscription_group_id).subscribe(
    val=>{
      let msg=""

      if(val=="success"){
        this.router.navigate(["/batch/groupings/index/",this.server_guardian_id])
        msg="Yes! Deleted"

      }else{
        msg="Nope!"
      }
      this.showAlert(msg)
    }
  )

}
showAlert(msg:String){
  Swal.fire({
  title: '<strong>Delete Grouping</strong>',
  icon: 'info',
  html: ""+msg,
  showCloseButton: true,
  allowOutsideClick: false,
  focusConfirm: true,
  confirmButtonText:'Close',
  confirmButtonAriaLabel: 'Close'
})
}

}


